import { trpc } from "../trpc";

/**
 * Create a folder in a different account the current user is a member of
 * (optionally nested under `parentId`). Backs the Folder Picker Modal's
 * inline "Create new folder" action — fired immediately on name confirm so
 * the new folder is real in the target account before the copy call.
 */
export function useCreateFolderInTargetAccount() {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.createFolderInTargetAccount.useMutation({
    onSettled: (_data, _error, variables) => {
      // Refetch the target-account folder list so the new folder shows up
      // next time the modal opens (and so the existing list is consistent).
      utils.folder.listFoldersForTargetAccount.invalidate({
        targetAccountId: variables.targetAccountId,
      });
    },
  });

  return {
    createFolderInTargetAccount: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
  };
}
